import {
    ABSENCES_FAILURE,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS,
    ABSENCES_REQUEST,
    ABSENCES_SET_TAB,
    APP_LOGOUT,
    LEAVE_OF_ABSENCES_FAILURE,
    LEAVE_OF_ABSENCES_REQUEST,
    LEAVE_OF_ABSENCES_SUCCESS,
} from '../actionTypes'

const initialState = {
    activeTab: null,
    leaveOfAbsences: [],
    loading: false,
    errors: [],
    employeeBalanceValues: null,
    employeeLoketLeaveBalance: null,
    currentPayrollPeriod: null,
}

const absencesReducer = (state = initialState, action = null) => {
    switch (action.type) {
        case LEAVE_OF_ABSENCES_REQUEST:
        case ABSENCES_REQUEST:
        case ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST:
            return { ...state, loading: true }
        case LEAVE_OF_ABSENCES_SUCCESS:
            return {
                ...state, loading: false, leaveOfAbsences: action.leaveOfAbsences,
            }
        case ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS:
            return {
                ...state, currentPayrollPeriod: action.currentPayrollPeriod,
            }
        case ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS:
            return {
                ...state, employeeLoketLeaveBalance: action.loketLeaveBalance, loading: false,
            }
        case ABSENCES_SET_TAB:
            return {
                ...state, activeTab: action.tab,
            }
        case ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE:
        case LEAVE_OF_ABSENCES_FAILURE:
        case ABSENCES_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        case APP_LOGOUT:
            return { ...initialState }
        default:
            return state
    }
}

export default absencesReducer
